import { useQuery } from "@tanstack/react-query";
import { useEffect, useState } from "react";

import api from "../api/api";
import type { FindUserReservationDocumentsOutputDto } from "../types/codegen";

// we need to wait for the reservation to be created before fetching documents
const INITIAL_DELAY = 3000;

export const useReservationDocuments = (reservationId?: string) => {
  const [isDelayComplete, setIsDelayComplete] = useState(false);

  useEffect(() => {
    if (reservationId) {
      const timer = setTimeout(() => {
        setIsDelayComplete(true);
      }, INITIAL_DELAY);

      return () => clearTimeout(timer);
    }
  }, [reservationId]);

  return useQuery({
    queryKey: ["reservations", reservationId, "documents"] as const,
    queryFn: async ({ signal }) => {
      return api.get<FindUserReservationDocumentsOutputDto>(
        `/reservations/${reservationId}/documents`,
        {
          signal,
        },
      );
    },
    select: (response) => response.data.data.documents,
    enabled: Boolean(reservationId) && isDelayComplete,
    refetchInterval: (query) => {
      const data = query.state.data;

      if (!data || data.data.data.documents.length === 0) {
        return 3000;
      }

      return false;
    },
  });
};
